export const WEBHOOK_AUTH_TYPE = {
  UNSPECIFIED: 'WEBHOOK_AUTH_TYPE_UNSPECIFIED',
  PUBLIC: 'WEBHOOK_AUTH_TYPE_PUBLIC',
  BASIC: 'WEBHOOK_AUTH_TYPE_BASIC',
  API_KEY: 'WEBHOOK_AUTH_TYPE_API_KEY',
  HEADER: 'WEBHOOK_AUTH_TYPE_HEADER',
  QUERY_PARAMETER: 'WEBHOOK_AUTH_TYPE_QUERY_PARAMETER',
} as const;

export type WebhookAuthType =
  (typeof WEBHOOK_AUTH_TYPE)[keyof typeof WEBHOOK_AUTH_TYPE];

export interface IWebhookStaticConfig {
  static_config: string[];
  names: Record<string, string>;
}

export interface IWebhookConfig {
  config_id: string;
  partner_id: string;
  url: string;
  created_at: string;
  updated_at: string;
  auth_type: WebhookAuthType;
  [payload: string]: string | boolean | undefined;
}

export interface IWebhookConfigUpsert {
  url: string;
  [payload: string]: string | boolean | undefined;
}

export interface IWebhookCredentials {
  config_id: string;
  partner_id: string;
  auth_type: WebhookAuthType;
  // Basic auth
  basic_username?: string;
  basic_password?: string;
  // Header / API_KEY auth
  header_name?: string;
  header_value?: string;
  // Query parameter auth
  query_parameter?: string;
  query_value?: string;
}

export interface IWebhookCredentialsUpsert {
  auth_type: WebhookAuthType;
  // Basic auth
  basic_username?: string;
  basic_password?: string;
  // Header / API_KEY auth
  header_name?: string;
  header_value?: string;
  // Query parameter auth
  query_parameter?: string;
  query_value?: string;
}

export interface IErrorNotif {
  notif_id: string;
  partner_id: string;
  email: string;
  created_at: string;
  updated_at: string;
}

export interface IErrorNotifUpsert {
  email: string;
}
